export default __webpack_public_path__ + "static/media/banner_2.ee1f7b82.jpg";